// node modules
import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

// app modules: actions
import { openModal } from 'actions/modals';

// app modules: components
import Icon from 'components/Icon';
import AddNewItem from 'components/SearchResults/AddNewItem';

// app modules: services
import history from 'services/history';

// app modules: props
import LoginProps from 'components/Login/LoginProps';

// app modules: constants
import { MODALS } from 'constants/view';
import { COLOURS } from 'constants/index';

class AddNewCollection extends Component {
  static propTypes = {
    openModal: PropTypes.func.isRequired,
    user: LoginProps.isRequired,
  };

  constructor(props) {
    super(props);

    this.state = {
      modal: null,
    };

    this.bound = {
      onClick: this.onClick.bind(this),
    };
  }

  onClick() {
    const { user } = this.props;

    if (user.logged_in) {
      this.openNewCollectionModal();
    } else {
      history.push('/login', { returnTo: history.location });
    }
  }

  openNewCollectionModal() {
    import('components/Collection/New/New.jsx' /* webpackChunkName: "collection-new", webpackMode: "lazy" */).then(
      module => {
        this.setState({
          modal: module.default,
        });
        this.props.openModal({
          name: MODALS.COLLECTION_NEW,
        });
      },
    );
  }

  render() {
    const { modal } = this.state;

    return (
      <Fragment>
        {modal ? React.createElement(modal) : null}
        <AddNewItem onClick={this.bound.onClick}>
          <Icon fill={COLOURS.SOLID_GREY} name="plus" height="24" width="24" />
          Create a new collection
        </AddNewItem>
      </Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
});

const mapDispatchToProps = {
  openModal,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(AddNewCollection);
